/**
 * 하루에 한 번, 다른 독자가 걸어둔 문장을 보여준다.
 *
 * 서버에 기록하지 않는다. "오늘 봤는지" 는 기기마다 달라도 상관없는
 * 종류의 상태이고, 이것 때문에 테이블을 늘릴 이유가 없다.
 */

/** 한국 날짜. UTC 로 자르면 자정부터 오전 9시까지가 어제로 묶인다. */
export function todayKST() {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Seoul",
    year: "numeric", month: "2-digit", day: "2-digit",
  }).format(new Date());
}

/**
 * 오늘 아직 안 봤으면 문장 하나를 고른다.
 *
 * 예전에는 프로필마다 하나뿐이라 users 목록에서 골랐다. 이제는 사람마다
 * 여러 개를 모으므로 quotes 에서 고른다 — 풀이 훨씬 넓어진다.
 *
 * @param {Array} pool    공개된 문장들 (listPublicQuotes 결과)
 * @param {string} myUid  내 문장은 뺀다 — 내가 쓴 걸 나에게 보여줄 이유가 없다
 */
export function pickDailyQuote(pool, myUid) {
  const others = (pool || []).filter((q) => q.text && q.userId !== myUid);
  if (!others.length) return null;

  const key = `muroo-daily-quote-${myUid || "guest"}`;
  const today = todayKST();
  try {
    if (localStorage.getItem(key) === today) return null;
    localStorage.setItem(key, today);
  } catch {
    // 저장이 막힌 브라우저에서는 띄우지 않는다.
    // 매번 뜨는 편보다 아예 안 뜨는 편이 낫다.
    return null;
  }

  const q = others[Math.floor(Math.random() * others.length)];
  return {
    text: q.text,
    bookId: q.bookId,
    bookTitle: q.bookTitle,
    bookAuthor: q.bookAuthor,
    name: q.name,
    avatar: q.avatar,
    userId: q.userId,
  };
}
